// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notificación para redirigir al cliente",
  "1d484fee4a": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos, Datos Comerciales, Departamento de Producto, Operaciones, Gestión de I+D, Plan de Versiones, Departamento de Atención al Cliente, Departamento de Administración, Departamento de Compras, Gestión Postventa",
  "a2c88dfb79": "Cree su primer equipo",
  "3cfdcc6086": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos/305, Administración de Personal/306, Operaciones, Gestión de I+D, Plan de Versiones, Gestión de Atención al Cliente/403, Departamento de Compras, Gestión Postventa",
  "ac45ec2c05": "Error de validación de inicio de sesión",
  "9aef9b8ccd": "Cuenta actual anómala. Por favor, vuelva a iniciar sesión y pruebe de nuevo",
  "728dd00f22": "Error de validación de este número de teléfono. Por favor, intente iniciar sesión con el código de verificación por SMS",
  "30dbecd916": "Su información contiene palabras sensibles. Por favor, modifique y vuelva a intentarlo",
  "12ed508d8a": "Sus acciones son demasiado frecuentes. Por favor, inténtelo de nuevo más tarde",
  "952d4a7595": "Estado de inicio de sesión de la cuenta actual anómalo. Por favor, vuelva a iniciar sesión y pruebe de nuevo",
  "e64bfdeaa4": "Error de validación de inicio de sesión. Por favor, obtenga un nuevo código de verificación por SMS",
  "79008a65f1": "Este número de teléfono está asociado con varias empresas. Por favor, inicie sesión en la empresa o cambie de número de teléfono",
  "bf242eff42": "El nombre de la empresa ya existe",
  "4f0cdb8374": "Por favor, introduzca un número de teléfono completo. Si utiliza un número de teléfono del extranjero, cámbielo por un número doméstico (86+)",
  "46e79ffeff": "Error al crear la empresa. Por favor, contacte al servicio de atención al cliente",
  "f3e18f0341": "Fallo en la validación de parámetros",
  "503fd1718d": "Fallo en el envío del código de verificación por SMS",
  "24b3129f19": "Envío de SMS demasiado frecuente. Por favor, inténtelo de nuevo más tarde",
  "1cde3e8245": "El código de verificación es incorrecto. Por favor, introdúzcalo de nuevo",
  "4212ecc031": "Demasiados intentos fallidos de verificación. Verificación temporalmente limitada. Por favor, inténtelo de nuevo más tarde",
  "735da9c347": "Fallo en la validación de nombre duplicado de empresa. Por favor, contacte al servicio de atención al cliente",
  "8731da9615": "Fallo en la validación del nombre de la empresa. Por favor, contacte al servicio de atención al cliente",
  "62e89b3f16": "Acepto el acuerdo de servicio",
  "c9b79027e5": "Enviar código de verificación",
  "84c1447b9d": "Se ha copiado correctamente",
  "fba4b0abd0": "Registro principal",
  "37f5a7cd41": "Valor TXT",
  "78b12427c9": "Verificando...",
  "59d089837c": "Actualmente no podemos verificar su dominio. Es posible que necesite esperar un tiempo para que el proveedor de hosting de su dominio actualice su información. Si después de un tiempo no hay respuesta, intente verificar nuevamente o cambie su dominio.",
  "4a5b7383d1": "Comprobando el dominio",
  "f24a492e40": "de los registros de verificación, puede cerrar esta página y volver más tarde para comprobar.",
  "c697ca5f1a": "Bienvenido a la versión empresarial",
  "ebb01b1740": "siguiente",
  "30109bf753": "¿Su empresa tiene un dominio?",
  "2b3e485b47": "Tengo un dominio empresarial",
  "1a7f5eae44": "No tengo un dominio empresarial",
  "bde15d6d84": "Necesita tener un dominio (por ejemplo, example.com) para crear una cuenta empresarial",
  "07ffb22c90": "Lo sentimos, necesita tener un dominio para crear una cuenta empresarial",
  "de23836563": "Introduzca el dominio para crear una cuenta empresarial",
  "287c07944a": "Verifique su dominio",
  "3ea2d528d5": "Siga los pasos a continuación para demostrar que es el propietario de <b>{domain}</b> y evitar que otros usen este dominio para registrar una cuenta empresarial.",
  "082b18ce56": "a. Abra el sitio web del proveedor de servicios de hospedaje de dominios en una <b>nueva pestaña</b> y <b>inicie sesión</b> en su cuenta;",
  "4f7e0841a9": "b. En el sitio web del proveedor de servicios de hospedaje de dominios, vaya a la <b>sección de registros DNS</b>. El nombre de la sección de registros DNS puede variar en el sitio web del proveedor, como <b>Gestión de DNS, Gestión de Servidor de Nombres, Panel de Control o Configuración Avanzada.</b>",
  "6365ad6e3a": "Luego, <b>regrese aquí</b> y haga clic en \"Siguiente\" para agregar el registro de verificación.",
  "8528892080": "Agregar registro de verificación",
  "7a225304f8": "a. En la página DNS, desplácese hacia la sección <b>TXT</b> y haga clic en el botón correspondiente para agregar el registro;",
  "b3cb7d947c": "b. <b>Copie y pegue</b> todos los valores a continuación en el <b>formulario TXT</b> del sitio web del proveedor de hospedaje de dominios;",
  "47213583bf": "c. <b>Guarde</b> el registro en el sitio web del proveedor de alojamiento de dominio, <br> luego <b>regrese aquí</b> y haga clic en el botón \"Verificar Dominio\" abajo.",
  "21486a57cf": "Nota: En el campo Nombre/Host/Alias, puede ingresar \"@\" o dejarlo en blanco. El proveedor de alojamiento de dominio puede requerir que ingrese su dominio en este campo (<su dominio>.com). Puede basarse en otros registros DNS para decidir cómo completar este campo. En el campo Tiempo de Vida (TTL), ingrese \"86400\" o deje el valor predeterminado.",
  "f1b8edab9c": "Cambiar Dominio",
  "7c6fc663a8": "Verificar Dominio",
  "b6aee9dc0d": "Verificación de Dominio Exitosa",
  "dd4cc429ea": "Ha demostrado que es el propietario de",
  "450f5c9230": "y prohibido a cualquier otra persona utilizar este dominio para registrar una cuenta corporativa.",
  "71cbcba755": "Haga clic en \"Siguiente\" para completar la creación de la cuenta corporativa.",
  "f4084f4870": "Por favor configure su cuenta de inicio de sesión",
  "fe3138baec": "Completar Creación",
  "0315cddedb": "La creación de la empresa fue exitosa",
  "91454a7f34": "Ahora inicie sesión en el panel de administración para crear cuentas corporativas para los miembros de su empresa.",
  "366304cde7": "1. Se cerrará automáticamente la sesión de la cuenta WPS actual.",
  "8a9f2a8422": "2. Debe usar la cuenta corporativa {account}@{domain} para iniciar sesión en el panel de administración.",
  "43e265e998": "Iniciar Sesión en el Panel de Administración",
  "9240efaaf0": "Mensaje de texto enviado",
  "e424bb9a6d": "Escriba",
  "d44d581706": "Nombre de la Empresa",
  "aa8679f406": ", 4-30 caracteres",
  "581bdb1f98": "no puede contener símbolos especiales \\ / : * ? \" < > | {}",
  "c13cabb67a": "correo electrónico:",
  "2b9b429e46": "Su correo electrónico",
  "5ed834a7df": "Por favor ingrese su correo electrónico",
  "acfd1f02ed": "Por favor ingrese un correo electrónico válido",
  "31c7c92cca": ", hasta 80 caracteres",
  "3f27cf84b3": "Ingrese el código de verificación",
  "a0ae1f3ec4": "Código de verificación incorrecto",
  "e5589c5e74": "Su nombre",
  "69d7bd63f6": ", solo se permiten caracteres chinos, letras y números",
  "91f008d258": ", máximo de 8 caracteres",
  "6ea6c9b39b": "Teléfono",
  "161042c5b7": "Por favor ingrese su número de teléfono",
  "e6b8eab1cd": "Por favor ingrese su número de teléfono, 11 dígitos",
  "3fd5fbb3cc": "Por favor ingrese su dominio",
  "cb5346ba8e": "Por favor ingrese un dominio corporativo válido, 4-30 caracteres",
  "27928eb7a4": "Cuenta",
  "8e19bd444d": "Por favor ingrese el nombre de la cuenta para iniciar sesión",
  "7bbbf479dc": "4-20 caracteres, solo números, letras o guiones bajos",
  "3d84cae479": "Por favor, introduzca una cuenta válida; el primer carácter debe ser una letra o un número",
  "c0d5ece1a7": "Contraseña",
  "f444036fa8": "Introducir contraseña",
  "b03218d72b": "La contraseña debe tener 12-16 caracteres con una combinación de letras mayúsculas y minúsculas, números o tres tipos de combinación",
  "b4ab05df50": "*En su empresa, alguien ya ha utilizado su dominio para una cuenta corporativa. Por favor, póngase en contacto con el servicio al cliente (400-677-5005) para demostrar que usted posee este dominio.",
  "c58876008f": "Error al copiar, por favor intente de nuevo",
  "86f73420de": "Enlace de invitación",
  "a58861962c": "Lo sentimos, su navegador actual no admite la descarga de este código QR",
  "228db07f78": "Departamento de Finanzas, Ventas, Gestión de Proyectos, Datos de Negocios, Departamento de Producto, Operaciones, Gestión de Investigación y Desarrollo, Planificación de Versiones, Servicio al Cliente, Administración, Compras, Gestión Postventa",
  "93896d7e98": "Cree un equipo y comience a colaborar con sus colegas",
  "e8f66fb75c": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos/305, Recursos Humanos/306, Operaciones, Gestión de Investigación y Desarrollo, Planificación de Versiones, Gestión de Atención al Cliente/403, Departamento de Compras, Gestión de Postventa",
  "831b73da9b": "El nombre no puede contener caracteres ni símbolos especiales no válidos /\\;:*?\"<>|%&",
  "51ab33b3ee": "Parámetro incorrecto",
  "a297f9e951": "Nombre de la empresa duplicado",
  "04d60ed5f5": "No se pueden usar palabras prohibidas",
  "2ff7bef083": "Error en el formato de dominio",
  "41e1ba2165": "Error de validación de información TXT del dominio",
  "50f348caa9": "Cuenta duplicada",
  "9d4c950d65": "Este nombre ya está registrado",
  "38cf19ed95": "El nombre de la institución ya existe",
  "4b426e7c9c": "Nombre de la institución",
  "298f880e18": "Ya existe, se recomienda agregar más información:",
  "1e67dd20b3": "Recuperar nombre de la institución",
  "517107cb04": "Usar otro nombre",
  "5667081882": "Crear con este nombre",
  "e306a979a6": "Relleno rápido:",
  "f583db96e0": "*Si el nombre de la organización está ocupado, puede",
  "9767148e34": "Por favor introduzca el nombre de la empresa u organización, de 4 a 100 caracteres",
  "e0e0ec159f": "Nombre de la institución",
  "5b13d254c0": "El nombre de la empresa ya existe",
  "92027671ec": "Nombre de la empresa",
  "36d482a7fb": "Recuperar nombre de la empresa",
  "79058a7577": "*Si el nombre de la empresa está ocupado, puede",
  "c96dd48dba": "Nombre de la empresa",
  "842efad336": "*Si es empleado de una empresa, por favor",
  "860f9bd77b": "Servicio de atención al cliente",
  "5a7ed18daf": "Unirse a la empresa",
  "ab470e9ace": "Información de contacto reservada",
  "0a7e0e48a7": "Nombre de la empresa solicitada para unirse:",
  "a8dc318dcc": "Por favor verifique la información de contacto que ha proporcionado, el servicio de atención al cliente de la plataforma le llamará pronto",
  "6ea1f4d7f5": "Enviar información",
  "d439e39f43": "Hemos recibido su información",
  "884653426b": "El servicio de atención al cliente le llamará dentro de 24 horas, ¡por favor conteste la llamada!",
  "2361cb14bf": "Escanee el código QR de WeChat para agregar al servicio de atención al cliente en línea y conocer el progreso",
  "50f45d0031": "Error al guardar",
  "fc856d0fd2": "Superadministrador",
  "e16c0676d2": "Administradores",
  "b1d2ddd126": "Miembro ordinario",
  "9d322cc08d": "El nombre de la institución no puede contener símbolos especiales \\ /:*?\"<>|{}",
  "b583ba7363": "El nombre de la empresa no puede contener símbolos especiales \\ /:*?\"<>|{}",
  "1d118a9bad": "El nombre de la organización debe tener al menos 4 caracteres, por favor ingrese un nombre de organización de 4 a 100 caracteres",
  "441b45b1f5": "El nombre de la empresa debe tener al menos 4 caracteres, por favor ingrese un nombre de empresa de 4 a 100 caracteres",
  "97457cb1f0": "El nombre de la organización ha superado los 100 caracteres, por favor ingrese un nombre de organización de 4 a 100 caracteres",
  "8ce00d3b92": "El nombre de la empresa ha superado los 100 caracteres, por favor ingrese un nombre de empresa de 4 a 100 caracteres",
  "a72778d3de": "El nombre debe tener al menos 2 caracteres, por favor ingrese un nombre de 2 a 10 caracteres",
  "79c17db5de": "El nombre ha superado los 10 caracteres, por favor ingrese un nombre de 2 a 10 caracteres",
  "482a118202": "El nombre solo admite caracteres chinos, números, letras y ·",
  "9a9be18941": "Por favor marque",
  "e6b7c4aa66": "Acuerdo de servicio en línea",
  "595023d905": "Crear Organización",
  "ba8c2df551": "Ocultar ubicaciones comunes",
  "d284384975": "Acuerdo de servicio en línea",
  "5c266d5a84": "Política de privacidad",
  "fcb92dbcf6": "Acuerdo de servicio en la nube",
  "2ae7a8a3f7": "Gracias por elegir el servicio de oficina en la nube WPS 365. A continuación, se presentan los principales aspectos del acuerdo legal entre usted y/o la organización que representa y Kingsoft Office, relacionado con el registro, la suscripción y el uso de este servicio.",
  "d30a6983bd": "Por favor, lea {0} | {1} | {2}, al hacer clic en \"Aceptar\", se considerará que acepta el contenido del acuerdo y nuestros servicios.",
  "263e306ede": "He leído y acepto {0} | {1} | {2}",
  "440129c0f1": "Por favor ingrese {0}",
  "8ab916983d": "Nombre de la empresa",
  "b01d68543b": "Su nombre",
  "684b30d4e9": "Su número de teléfono",
  "a48427e8e2": "Para establecer una plataforma de trabajo para su empresa",
  "3a81b0f1fc": "Para facilitar que sus colegas lo encuentren en el sistema y colaboren",
  "52bc539b6e": "Confirmar Creación",
  "b2fe245e19": "Crear empresa/equipo: Compartir y colaborar en archivos",
  "893282d3f7": "Por favor complete la información de la empresa:",
  "cc997bf6aa": "Confirmar",
  "50fdde51ac": "{0}, de {1} a {2} caracteres",
  "a19cc5ec18": "{0} no puede contener símbolos especiales \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, Solo se permiten caracteres chinos, letras y números",
  "f4080b1431": "{0}, Longitud máxima de {1} caracteres",
  "88e59b2d58": "{0}, 11 dígitos",
  "91d6d4e105": "Por favor, introduzca el código de verificación",
  "bec71bde96": "Código de verificación incorrecto",
  "e20ff8ee19": "{0} es obligatorio",
  "8dc09d10d7": "No se puede encontrar dwId",
  "a03766ce6c": "Escuela",
  "03542addfe": "empresa",
  "adb8a815d1": "Límite alcanzado al vincular el número de teléfono {0}",
  "97a6b66f1d": "El número de teléfono actual ya está vinculado a {0}",
  "665e465487": "No se puede crear {0}, el número de teléfono actual \"<strong>{1}</strong>\" ya ha alcanzado el límite máximo de {0} vinculados (máximo 5 {2}), puedes acceder a los {3} ya vinculados a continuación:",
  "a85b1367ca": "El número de teléfono actual \"{0}\" ya está vinculado a {1}, puedes seleccionar los {2} existentes para iniciar sesión o crear un nuevo {3}:",
  "bf992ce17b": "Utilizar otro número de teléfono para crear {0}",
  "395ea04444": "Crear nuevo {0}",
  "4ce3bb86b3": "Límite excedido para unirse a {0}",
  "df88c4b7a5": "El número de teléfono actual \"{0}\" ha alcanzado el número máximo de {1} vinculados",
  "78f7dd59ca": "El número de teléfono actual \"{0}\" tiene los siguientes {1} vinculados, puedes cambiar directamente el uso",
  "8db491a3f8": "Continuar creando nuevo {0}",
  "83f6d9e1e4": "Intentar de nuevo",
  "1dc5f11612": "o",
  "217d76f53e": "Comentario",
  "b69a6ea62a": "Por favor, mantenga presionado el botón izquierdo del ratón para raspar los dos escudos",
  "3a31f64800": "¡Felicidades por haber raspado exitosamente el escudo!<br/>Continúe al siguiente paso",
  "6a81fcee96": "Cargando",
  "e97877a65d": "Oh, el escudo ha desaparecido<br/>Por favor",
  "8d85456145": "He estado esperando demasiado tiempo<br/>Por favor",
  "77ad847b95": "La red es realmente lenta<br/>Por favor",
  "dbd1ae3a34": "Ha raspado demasiado rápido<br/>Por favor",
  "bd8e05cd53": "Haga clic en el botón para iniciar la verificación inteligente",
  "63d2a8a722": "Verificación exitosa",
  "73141928ad": "Verificación fallida, por favor haga clic en el botón para refrescar",
  "04856c5c8a": "Detección inteligente en curso",
  "52cd9bd26d": "Su operación no está autorizada",
  "fd157e8ea8": "Creación guiada",
  "c6225c5b2b": "Bienvenido a la versión empresarial",
  "e33423fb1e": "Creación exitosa",
  "7b0c035999": "Página de creación exitosa de la empresa de Kingsoft Docs",
  "85db8faae0": "Manual de uso de la versión empresarial",
  "20591b9b44": "Recuperar nombre de la empresa",
  "b023d76dc2": "Guía de carga de miembros",
  "e2f454e095": "La empresa de {0}",
  "df466f942b": "División",
  "26a7b797c4": "Centro de servicios",
  "5fc82b360b": "Plataforma de oficina todo en uno, para una mayor eficiencia en el trabajo",
  "f2e736d52e": "Bienvenido a la versión empresarial",
  "becc41a35b": "Nombre de la empresa",
  "74685cdc58": "Por favor, introduzca el nombre de la empresa u organización, de 4 a 100 caracteres",
  "07b55b1907": "Tamaño de la empresa",
  "77b2f763ad": "Seleccione el tamaño de su empresa",
  "49d2509109": "Menos de 5 personas",
  "8db2c9b74a": "6-20 personas",
  "a9fb0cf14a": "21-50 personas",
  "0fed41f8d3": "51-100 personas",
  "fb33f25a04": "101-200 personas",
  "3e3ff0f52e": "201-500 personas",
  "cd8b51f634": "501-2000 personas",
  "0662fa6eec": "Más de 2000 personas",
  "69334dba1a": "Requisitos empresariales",
  "79994e749c": "(Recomendaremos las mejores soluciones de práctica industrial)",
  "840a017f38": "Seleccione el problema que desea resolver",
  "f045b05c73": "Ingrese los requisitos para crear su empresa",
  "d8efb0b36d": "Más",
  "adcb8fbb0c": "Número de teléfono habitual",
  "eb1c73e2ca": "Ingrese su número de teléfono habitual de 11 dígitos",
  "7f276e7dfa": "Crear gratis",
  "c391b3eec1": "Error al enviar el mensaje",
  "54f4cb8fa7": "Mensaje enviado",
  "231eb1fa1e": "Usuario empresarial {0}",
  "272b0f9d32": "Usuario corporativo",
  "b209a67331": "Error al crear la empresa, por favor actualice la página.",
  "acb08d0cc9": "Tercer paso para crear empresa",
  "83db361f51": "Después de la creación, active la lógica de redirección",
  "1e930326e3": "handleStep para ir al siguiente paso",
  "184df5c725": "Error al guardar formulario",
  "736eab3023": "Validación de envío",
  "2db62dc13c": "Error de validación",
  "54fb0afaea": "Validación exitosa",
  "d39cff3fcf": "Omitir el ahorro extremo solo para descubrir la necesidad del código de verificación",
  "305b777ae5": "Error al verificar el nombre, abriendo ventana emergente \"Nombre de la empresa ocupado\" y almacenando nombre",
  "e57b6686b2": "Verificar si el sujeto de autenticación ya ha sido autenticado, abrir ventana emergente de protección de autenticación y almacenar información del tema autenticado",
  "f7c86f496d": "La Creación Del Nombre Está Duplicada || El Código De Verificación Ha Expirado Si Hay Problemas, Se Bloquea La Ejecución",
  "cb37db4fd4": "Fallo Al Manejar La Presentación",
  "243a569fc4": "Este nombre ya ha sido registrado, por favor use otro nombre",
  "196851a3d9": "Usuario empresarial {0}",
  "0c3a3595ff": "Usuario corporativo",
  "a33b41e0f2": "Error al crear la empresa, por favor actualice la página.",
  "fcce6a7156": "Creación exitosa",
  "5ec6da58a6": "Notificar al cliente",
  "259c9dfa4e": "Lógica de versión profesional",
  "864156930f": "Lógica de vba",
  "7824efd172": "Docs para móviles",
  "52b6cfaaaf": "Cliente WPS",
  "c7c51beea9": "Versión educativa",
  "8d054d4986": "Versión predeterminada",
  "b597e18fb1": "isWps365PcClient y tiene openurl",
  "b0c13de2a0": "isWps365PcClient o no cliente, tiene openurl",
  "7d0f2ce18c": "isWps365PcClient o no cliente, tiene openurl y éxito en el callback",
  "e2c5a07df6": "No cliente No openurl",
  "29e0414d1f": "No cliente No openurl callback",
  "60861f7d2a": "AutoChange lo delega al equipo de negocio para que lo cambie",
  "7c83140d90": "Estado de visitante creado, no necesita usar SDK para cambiar cuenta (SDK no admite visitantes), código ya ha cambiado con éxito",
  "3379b09e59": "Con openurl y usando href para cambiar",
  "586ff04c22": "Redirección individual",
  "b6c91f218b": "useSuccessSkip falló",
  "47d2f3ba66": "Más",
  "57551f86ce": "Actuar según el origen de utm para activar diferentes métodos",
  "64fe3758e2": "Su operación no está autorizada",
  "4da3e1262f": "Creado con éxito, comienza tu viaje de oficina empresarial",
  "c38dfb8c6c": "Crea tu primer equipo",
  "38dddb483b": "Entrar a la empresa",
  "614d9c91eb": "Invitar a miembros a unirse",
  "97f1eca0aa": "Entrar a la empresa",
  "13a4939e90": "Unirse a la invitación de la empresa",
  "a319e4ae0a": "Invitar a compañeros de trabajo a unirse",
  "12e4da6bba": "Invitar a compañeros de trabajo ahora",
  "bd885380f6": "Error al obtener el enlace de invitación",
  "5e626c4063": "SMS enviado",
  "3dc09e7cfd": "La cantidad de nombres de empresas que ha solicitado recuperar ha alcanzado el límite",
  "48318f41f9": "Invitar a miembros a unirse",
  "45441baac4": "Te invita a unirte a {0} para colaborar",
  "e5847fbd67": "Copiar enlace, invitar a miembros",
  "23101dd40a": "Personalizando soluciones para usted",
  "71bb7e54a8": "Gestión de proyectos",
  "aff37c79cc": "Experimenta el plan seleccionado",
  "a97b174258": "¡Invite a 2 colegas más y obtenga gratuitamente los siguientes beneficios empresariales!",
  "253855849f": "Comparte enlace de invitación al grupo de trabajo para invitar a colegas",
  "57b0a2a63f": "Copiar enlace, invitar a colegas",
  "71c0a37ee1": "Entrar a la empresa",
  "f848c60e0e": "Invita a <color:red>2</> colegas más para obtener gratis los siguientes beneficios empresariales",
  "664e32b4fe": "Página de invitación Entrar a la empresa",
  "872f14403a": "Invitar a compañeros de trabajo a unirse",
  "1880e7deb9": "Invitar a compañeros de trabajo ahora",
  "cc2a9aaf82": "Creado con éxito",
  "02a13e2583": "¡Invite a 2 colegas más y obtenga gratuitamente los siguientes beneficios empresariales!",
  "5d3593cdce": "Error al obtener información del equipo",
  "c025113ea1": "Error al obtener el enlace de invitación",
  "b83bc1e485": "Enlace de invitación",
  "0996ced9f6": "Lo siento, su navegador actual no admite la descarga de este código QR",
  "1e88451e31": "Enlace de invitación copiado",
  "bb969cabcd": "Error al copiar, por favor intente de nuevo",
  "15e1f79c7a": "Solicitar unirse a la empresa",
  "59c22b4ef8": "Recibió un enlace de invitación",
  "0f0b392e60": "Crear Su Primer Equipo",
  "0437d07c43": "Nombre De La Empresa",
  "41800c7bf1": "Introduzca El Nombre Del Creador",
  "1ec5999511": "El Nombre Del Creador Tiene Un Máximo De 8 Caracteres",
  "02da35b4e4": "El Nombre Del Creador Solo Puede Incluir Caracteres Chinos, Letras, Números",
  "184e9f6616": "Introduzca Un Número De Teléfono",
  "9b587898ba": "Introduzca Un Número De Teléfono Válido",
  "e68c164a02": "Introduzca Su Correo Electrónico",
  "0b1de22df7": "Introduzca Un Correo Electrónico Válido",
  "61026181ab": "Licencia Comercial Es Obligatoria",
  "c3847e604e": "El Tamaño Del Archivo Excede 10M, Por Favor Seleccione De Nuevo",
  "49450f4ec7": "Formulario De Reclamación De Nombre Obligatorio",
  "39c3b8fa1d": "Error De Envío",
  "3ea44d7963": "Carga Exitosa",
  "5b1aa3c2c4": "La carga ha fallado.",
  "7e7f81eaa3": "Error De Carga, Archivo Mayor De 10m",
  "2ff1913de1": "Error de carga, el archivo debe ser .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Licencia Comercial Es Obligatoria",
  "66bda65057": "El Tamaño Del Archivo Excede 10M, Por Favor Seleccione De Nuevo",
  "8f2305a83d": "Formulario De Reclamación De Nombre Obligatorio",
  "55ff0c8c6e": "Error De Envío",
  "8dad6d950d": "Error De Obtención De Información De Invitación",
  "a5f0ac3a9a": "Creación Exitosa",
  "4f1d069770": "Los Parámetros Utm De Acceso A La Página De Invitación Son {0} Y Nombre {1}",
  "f9578cfe6d": "Los Parámetros Utm De Acceso De La Guía En Dos Pasos Son {0} Y Nombre {1}",
  "e10d028405": "Guía En Dos Pasos Pcoffice Creado",
  "8e22e4fcc4": "Enlace De Invitación Copiado",
  "3f327f9f37": "Error De Copia, Por Favor Intente De Nuevo",
  "bd1aecb265": "Cancelar",
  "b6abf9b19a": "Aceptar",
  "e910d9cc0f": "Cancelar",
  "37ab25522d": "Aceptar",
  "196b3eb9cf": "Escanea Para Unirte",
  "2b81c52e20": "Descargar Imagen",
  "62152fd9f3": "Invitación De Enlace",
  "e0a3725651": "Lo Siento, Su Navegador Actual No Soporta Descargar El Código QR",
  "8b7883b2c7": "Escanea Para Unirte",
  "9e9a659ed5": "Descargar Imagen",
  "0d55065a9a": "Invitación De Enlace",
  "487cf6a106": "Lo Siento, Su Navegador Actual No Soporta Descargar El Código QR",
  "78fd005d1f": "Introduzca Su Número De Teléfono",
  "f909563857": "Usar Este Número Para Crear",
  "a26a19f139": "Cancelar Creación",
  "cc004ac9ee": "Número De Teléfono",
  "4df8c3c588": "Introduzca Otro Número De Teléfono Para Crear Escuela",
  "3151cabb3d": "Introduzca Otro Número De Teléfono Para Crear Empresa",
  "56098a71eb": "Haga Clic En Validación Inteligente, Enviar Código De Verificación",
  "e96ec218e4": "Introduzca El Código De Verificación SMS",
  "ce619a0225": "Código De Verificación SMS Enviado A",
  "0e9863aaeb": "Código De Verificación Incorrecto, Por Favor Introduzca De Nuevo",
  "32dc8629e1": "Segundos Para Reenviar",
  "e4eda9add5": "Volver a enviar",
  "b007977564": "Error De Obtención De Información De Aprobación",
  "d8852ffc9c": "Acceso No Administrador",
  "8a733a2574": "Acceso Desde Móvil",
  "9e8c152c4f": "Acceso Desde PC",
  "2265a55e93": "Aceptar el acuerdo de servicio",
  "80dabe5aa3": "Crear tutorial",
  "7deee8bf5a": "Guía en dos pasos creada por docsWeb",
  "69eb501ecb": "Su apelación ha caducado, no se puede acceder",
  "aa1d9d98ad": "Permiso insuficiente, no se puede acceder",
  "fdf2fe129e": "Crear Organización",
  "7f0ca0df6b": "Ocultar ubicaciones comunes",
  "cc6ac2a93c": "Guía en Dos Pasos Base Montada",
  "5d6c570bf0": "Guía en Dos Pasos Antes de Cerrar",
  "a4eb8a192d": "Equipos que Todos Están Creando",
  "4912e16a9d": "El nombre de la empresa se ha recuperado",
  "41c4e87ef2": "Puede hacer clic en el enlace",
  "5e630930c0": "Volver a Crear Empresa",
  "436a563524": "Si ya ha creado una empresa, puede consultar",
  "0b6e7cbe7f": "Cómo modificar el nombre de la empresa",
  "cb7bce0775": "Tutorial para Modificar el Nombre de la Empresa",
  "3feadd3040": "La versión actual es demasiado baja para usar la empresa",
  "3cf23de936": "Su versión de software es demasiado baja, la función empresarial no está disponible. ¡Por favor, vaya a actualizar la versión del software en la tienda de aplicaciones!",
  "a1c5d5d202": "Aceptar",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Seguro, Sincronización, Colaboración",
  "c870026dfc": "Inicio de sesión de WeChat",
  "e7647cd875": "Inicio de sesión con cuenta de WPS",
  "07b380074b": "Inicio de sesión de QQ",
  "67921724dd": "Otras Formas",
  "254da8a9f5": "El número de unirse/crear empresas ha alcanzado el límite",
  "3648e4811b": "Acceder a Docs",
  "dcd102b346": "Crear Equipo Personalizado",
  "8b9b258cbf": "Ingrese el Nombre del Equipo Aquí",
  "19bb6e0ded": "Los Miembros de WPS disfrutan de",
  "2d9fe8d938": "Privilegios de Oficina, para ayudarle a resolver problemas de documentos en su oficina diaria, ¡venga y experiméntelo!",
  "e8c1caa649": "Subir desde el Local",
  "03641083a3": "Mover desde Documentos personales",
  "eecd3ab9b5": "Próxima vez",
  "13b447b3a8": "Reemplazar",
  "3c2fc507fc": "La versión actual es demasiado baja para usar la empresa",
  "c3615d8134": "Su versión de software es demasiado baja, la función empresarial no está disponible. ¡Por favor, vaya al sitio web oficial a actualizar la versión del software!",
  "644a36e05b": "Actualizar",
  "d435105f21": "El número de unirse/crear empresas ha alcanzado el límite",
  "73a286ceb0": "Acceder a Docs",
  "c2cec645c0": "Cancelar",
  "b5f5b83c0f": "Aceptar",
  "76ec352da5": "Escanear Código para Invitar a Compañeros",
  "6a509e4487": "Descargar Código QR",
  "940cc4a546": "No se puede Crear Empresa",
  "78b2a62ea5": "Ingrese en la Empresa Existente o Cree una Nueva Empresa",
  "3a6da7f6f9": "El número de empresas vinculadas al número de teléfono actual ha alcanzado el límite (máximo 5 empresas)",
  "93bab52870": "El número de teléfono actual ya está vinculado a una empresa; puede elegir iniciar sesión en una empresa existente:",
  "ce6e0adaf2": "Puede optar por ingresar a la empresa vinculada a continuación:",
  "1ce200a92b": "Seleccionar",
  "bb91ef2999": "Crear Nueva Empresa",
  "024e4a91e5": "El nombre de la empresa ya está registrado",
  "eb089a23a0": "Este nombre de empresa ya está registrado:",
  "7646558701": "Administrador:",
  "1d9c02bd33": "Fecha de registro:",
  "919fc7805f": "Se recomienda intentar contactar a sus compañeros mencionados.",
  "0ca71a9344": "También puede utilizar temporalmente otro nombre para crear una empresa (puede cambiarlo más tarde) y luego presentar una apelación.",
  "e83a244e90": "Haga clic para saber cómo apelarse.",
  "d22bedfb21": "Aceptar",
  "907b78b6e5": "Ingrese el nombre del grupo de trabajo o equipo",
  "7195b0ac1e": "Equipo que puede querer crear",
  "60ed4f915e": "siguiente",
  "f5ba8dfb7b": "Omitir Guía",
  "5c44a3ef68": "Máximo 100 caracteres",
  "130c53fb20": "El nombre no puede contener caracteres ilegales ni símbolos especiales /\\;:*?\"<>|%&",
  "e832d41acc": "Guía de Dos Pasos Omitir",
  "80d9cf7177": "Guía de Dos Pasos Refrescar",
  "0aebf80435": "Guía de Dos Pasos Hacer clic en label",
  "e74f515977": "Guía de dos pasos HandleSubmit",
  "308d2a53c9": "Guía de dos pasos CreateGroup",
  "dda2ed7e18": "Guía de Dos Pasos Error al crear equipo",
  "ded3c35500": "Error al crear equipo",
  "4f18031bc1": "Guía de dos pasos CreateTemplate",
  "091e5cefcc": "Guía de dos pasos CreateTemplate Error",
  "58cf4e00f0": "Código de Verificación",
  "92abbf0385": "Enviar Código de Verificación",
  "f0f9976ef9": "Por favor ingrese su número de teléfono móvil",
  "a4ce99b1df": "Código de Verificación",
  "39d36e0f9f": "Confirmar",
  "0fd8a01938": "Enviar",
  "9048a4e842": "Número de Teléfono Móvil",
  "9afa1091eb": "Reenviar",
  "58d787001f": "Ingrese otro número de teléfono móvil para crear la escuela",
  "450905a265": "Ingrese otro número de teléfono móvil para crear la empresa",
  "f7386de3c6": "Seleccione del desplegable",
  "27aa05a92c": "Aceptar los Términos de Servicio",
  "80af61cb57": "Volver a la página anterior",
  "50149b8d4f": "Nombre del Solicitante",
  "e6756f8749": "Ingrese su nombre",
  "3cbd51a2b1": "El nombre debe tener al menos 2 caracteres, por favor ingrese un nombre entre 2 y 10 caracteres",
  "4f79b4813f": "El nombre solo admite caracteres chinos, números, letras y ·",
  "71d3e75983": "Número de Teléfono Móvil Habitual",
  "afe5149035": "Ingrese su número de teléfono móvil habitual",
  "1e9270b50f": "Por favor ingrese su número de teléfono móvil habitual, 11 dígitos",
  "ff5dc98dfb": "Saltar",
  "165be2ab43": "Volver al Paso Anterior",
  "231d8a335a": "Aceptar los Términos de Servicio",
  "1cad008ffc": "El nombre de la empresa {0} ya está registrado, por favor use otro nombre",
  "c6e274fcab": "Confirmación de Acuerdo",
  "b9352504bb": "Cerrar ventana de acuerdo",
  "8409e99ad0": "Abrir ventana de acuerdo",
  "1593c6dd95": "Enviar",
  "4f44a9de22": "Abrir verificación de SMS",
  "26b70c68b8": "Omitir, entrar directamente a la empresa",
  "a8bebcb302": "Volver a la página anterior",
  "c800b4fec5": "Página de invitación Base Montado",
  "38b396d5b0": "Página de invitación DocsWeb Montado",
  "2eb7f9a9f1": "Su apelación ha sido enviada con éxito",
  "2c6f3590fb": "Esperamos enviar el resultado del procesamiento a su correo electrónico en un plazo de 3 días hábiles,",
  "2ea3eff708": "por favor esté atento.",
  "53acfba22c": "Invite a su colega ahora",
  "4e6d282f4f": "Aceptar la invitación para unirse a la empresa",
  "5f72f4b936": "Invite a su colega ahora",
  "e5383077ba": "Recuperar nombre de la empresa",
  "06e3fa2350": "Tras la consulta,",
  "653a263b5e": "el creador es",
  "769f57269f": "El número de teléfono del creador es",
  "09a224695e": "Por favor, confirme si el creador de esta empresa es su colega",
  "3beda6c149": "Si es su compañero de trabajo, puede contactarlo.",
  "5c74dd10d1": "Modificar nombre de empresa o transferir el administrador superusuario.",
  "da504edb0f": "Si no es su compañero de trabajo, puede hacer clic en el botón de abajo para continuar recuperando el nombre de la empresa.",
  "39194faaf1": "Continuar recuperando nombre de empresa",
  "e22b829e90": "Se ha copiado correctamente",
  "6e1b44752a": "Valor TXT",
  "79881b1d7a": "Invitar a colegas ahora",
  "a5344a45f9": "Haga clic en la esquina superior derecha y seleccione \"Enviar a amigos\"",
  "a4954a5b08": "Invitar a colegas ahora",
  "8e3a1625fb": "Recuperar nombre de empresa",
  "bf8b8c7005": "Subir licencia de negocio",
  "bfd44a66c9": "Haga clic para seleccionar",
  "d503f20925": "Por favor, suba una copia escaneada o una foto de la licencia de negocio",
  "cbebe043c5": "Admite formatos JPG, JPEG, PNG, BMP, PDF, tamaño no superior a 10 MB.",
  "9650b96d7d": "Subir formulario de apelación por nombres duplicados",
  "c3b8ae46d3": "Por favor, suba una copia escaneada o una foto del formulario de apelación por nombres duplicados",
  "9e325a9e09": "Descargar plantilla de formulario de información",
  "a4711aae88": "Enviar solicitud",
  "3a5cc1441e": "Verificando...",
  "0bd7bf8511": "Actualmente no podemos verificar su dominio, puede que necesite esperar un tiempo para que el proveedor de servicios de alojamiento del dominio actualice la información. Si después de un tiempo aún no hay respuesta, intente verificar nuevamente o cambie de dominio.",
  "fae48d554b": "Revisando el historial de verificación del dominio",
  "5e1779a0ca": "Puede cerrar esta página y volver más tarde para ver.",
  "ca85f8b836": "Bienvenido a la versión empresarial",
  "2570e0f00b": "Error de inicio de sesión",
  "40d16a007e": "Tu cuenta personal ha sido vinculada automáticamente",
  "81376b92e4": "Reinicie sesión con {0} para cambiar a la cuenta empresarial.",
  "ba679ba739": "Entendido, ir a iniciar sesión",
  "c05f64c6c6": "Después de {0}, automáticamente ir a iniciar sesión",
  "c329ccef3a": "Error de inicio de sesión",
  "e370f9afb1": "Tu cuenta personal ha sido vinculada automáticamente",
  "410cf42585": "Por favor, vuelva a iniciar sesión para cambiar la cuenta de empresa.",
  "062d48aece": "Entendido, ir a iniciar sesión",
  "95a105d412": "Después de iniciar sesión, automáticamente ir a iniciar sesión",
  "2d000d5a6d": "Enviar enlace para compartir a los miembros, quienes pueden solicitar unirse cuando lo abran",
  "8861b6e90d": "Entrar a la empresa",
  "25b9f72fda": "Error en parámetros de página",
  "1c76123efc": "Error al obtener enlace de invitación",
  "6caba48b76": "Saltar",
  "f66379c650": "Error en parámetros de página",
  "c45021de2a": "La creación ha fallado.",
  "011d470126": "La plataforma protege continuamente la seguridad de su información",
  "f1a44d9151": "La plataforma ha obtenido certificados ISO27001 e ISO27701 de BSI internacional y ha pasado las evaluaciones de seguridad de nivel tres del país.",
  "255ea5dff7": "Libro Blanco de Seguridad",
  "bb55b124f2": "Crear Demostración Empresarial",
  "61e24974a3": "Crear Contenido de Estrategia para Obtener Empresa",
  "bfdf78febe": "Siguiente Paso para Completar Información",
  "c4aa2d2d60": "Introduzca el Nombre del Grupo de Trabajo o Proyecto",
  "b69765ab64": "Equipos que Todos Están Creando",
  "9657d9408b": "Reemplazar",
  "e21da8c16a": "siguiente",
  "224ef5cc9f": "Omitir Guía",
  "641f58c8f6": "La Empresa Actual No Permite Que los Miembros Creen Equipos, Por Favor Practica Como Administrador Para Crear Uno",
  "efea622752": "Copiar Enlace, Invitar a Compañeros",
  "fd5b40a9fd": "Te invita a unirte a {0}, para colaborar juntos",
  "b04dd2f10a": "Enlace de Invitación Copiado",
  "d1606a1b1a": "Falló la Copia, Por Favor Intenta de Nuevo",
  "0d59f3db83": "Introduzca el Departamento de Proyecto o Equipo, Como 'Departamento de Ventas'",
  "9429513d34": "No Se Necesita Guía",
  "b54a20b1ff": "La creación ha fallado.",
  "093fa0fb74": "Autorización de Inicio de Sesión...",
  "b383b136f4": "Inicialización del Proyecto Empresarial",
  "b6b21b388b": "El Nombre de la Empresa ya Ha Sido Registrado",
  "285dc68c10": "El Nombre de la Empresa ya Ha Sido Registrado: ",
  "1bf685b89d": "Administrador: ",
  "7b4297edcc": "Fecha de Registro: ",
  "fa51ea19fc": "Se Recomienda Buscar y Contactar con Sus Compañeros Mencionados.",
  "e3678a996d": "También Puede Usar Otro Nombre Temporalmente para Crear una Empresa (Se Puede Modificar Más Tarde) y Luego Presentar una Apelación.",
  "5969bc8071": "De acuerdo",
  "ba4cf699df": "Recuperar Nombre de la Empresa",
  "afecee4eb4": "Su Nombre",
  "a8bdebc614": "Por Favor Ingrese su Nombre",
  "5bbeb38a66": "Teléfono",
  "b4f7b44b7a": "Por Favor Ingrese su Teléfono de Contacto",
  "cac2913686": "Correo Electrónico de Contacto",
  "23d3bb3a42": "Por Favor Ingrese su Correo Electrónico de Contacto",
  "ea106a393c": "Subir Licencia Comercial de la Empresa",
  "f74131d71e": "Haga Clic para Seleccionar",
  "53749c51c5": "Por Favor Suba el Escaneo o Foto de la Licencia Comercial de la Empresa",
  "c00f2ea171": "Soporta Formatos JPG, JPEG, PNG, BMP, PDF, Tamaño No Superior a 10 MB.",
  "57ec07fa97": "Subir Formulario de Apelación por Nombre Duplicado",
  "8eb0606e94": "Por Favor Suba el Escaneo o Foto del Formulario de Apelación por Nombre Duplicado",
  "f59e76c0b0": "Descargar Plantilla de Formulario de Información",
  "030bd26fa4": "Enviar Solicitud",
  "0a602dc727": "Almacenamiento Seguro de Datos",
  "9138f28acf": "Colaboración y Compartición de Archivos",
  "b3a306cf90": "Legalización de Información",
  "973c53f725": "Se Recomienda Cambiar el Nombre, Después del Registro Puede Presentar la Certificación de la Institución y Actualizar el Nombre",
  "f886f5e92f": "Se Recomienda Cambiar el Nombre, Después del Registro Puede Presentar la Certificación de la Empresa y Actualizar el Nombre",
  "b8051702a3": "Este Nombre Contiene Palabras Sensibles, Por Favor Ajuste el Nombre o Contacte al Personal de Servicio al Cliente",
  "d73881f7d4": "El Nombre de la Empresa Está Protegido",
  "dc7e58e320": "El Nombre de la Empresa Está Protegido, Se Requiere Verificar la Información del Titular Antes de Usarlo. Se Recomienda Cambiar el Nombre de la Empresa o Después del Registro Usar Este Nombre al Pasar la Certificación Empresarial.",
  "20c3bc070c": "Confirmar",
  "c4278e5f28": "Permisos insuficientes",
  "9217efae21": "La cuenta con la que ha iniciado sesión no tiene permisos para crear, por favor contacte a su representante de ventas",
  "52ff08f2ad": "El nombre de la institución está protegido, por favor ajuste el nombre de la empresa",
  "79386ae280": "Por favor, introduzca un código de verificación de 6 dígitos",
  "d7b2c5a41b": "El código de verificación ha sido enviado a",
  "ce2e1c26f7": "(Válido durante 10 minutos)",
  "59d338903f": "Puede volver a obtener el código de verificación en {0} segundos",
  "5aadd14136": "Volver a Obtener el Código de Verificación",
  "90f5c93432": "Este nombre ya ha sido registrado",
  "1677072f4a": "Puede proporcionar más información o registrarse con otro nombre",
  "3b8459fb1e": "Rellenar Rápidamente:",
  "6f38edbcb1": "Registrarse con Este Nombre",
  "8406c81e2d": "Sucursal",
  "29d323fa85": "Subcentro",
  "4f0e806e02": "Departamento de Finanzas",
  "3f935efb6b": "Aceptar el Acuerdo de Servicio",
  "b42241be05": "Más tarde",
  "99de4b33b7": "Aceptar",
  "7f867e7395": "Crear empresa con otro número de teléfono",
  "0d51a8f7a6": "Continuar Creando",
  "8bdaecf2e5": "Por favor, introduzca su número de teléfono",
  "565ae60c8a": "Por favor, introduzca su nombre",
  "f76e06d0e7": "Por favor, introduzca su número de teléfono",
  "7b0fca5255": "Por favor, introduzca el código de verificación",
  "68026d2d25": "Bienvenido a la versión empresarial",
  "d25b5541be": "Crear Gratis",
  "32cfd73733": "Por favor, introduzca el nombre del equipo, empresa u organización",
  "4cf83dc4a0": "Crea rápidamente en un minuto y colabora eficientemente con tus colegas",
  "d320d37116": "Crear Equipo o Empresa Gratis",
  "c54b475dd2": "Acuerdo de Usuario",
  "190d54e616": "Empresa de {0}",
  "8c1b768ac4": "Fallo en la verificación inteligente",
  "d74eab0f35": "La información de su nombre de empresa no cumple con las normas de la plataforma, por favor modifíquela e intente de nuevo",
  "0f3d62dd4f": "La información de su nombre no cumple con las normas de la plataforma, por favor modifíquela e intente de nuevo",
  "647cf2211b": "No se admite la creación con el número de teléfono actual, por favor use otro número",
  "b63d96cdae": "La información proporcionada no cumple con las normas de la plataforma, por favor modifíquela e intente de nuevo",
  "2dbbe8e43f": "No se admite la creación con el número de teléfono actual, por favor modifíquelo e intente de nuevo",
  "b18abc5de6": "Sin número de teléfono vinculado",
  "f5233dae6f": "Por favor, cambie el número de teléfono para crear",
  "4167c8b88d": "El número de teléfono actual puede presentar las siguientes situaciones, intente cambiar el número para crear. Si tiene alguna pregunta, por favor contacte al servicio de atención al cliente.",
  "a8a2433c4d": "Escanea el código QR con WeChat para agregar y contactar al servicio de atención al cliente",
  "444a639c09": "Entiendo",
  "69a097057f": "El número de teléfono actual pertenece al segmento de operador virtual <#BB2726>",
  "4370b06fd0": "El número de teléfono actual presenta comportamiento de uso anómalo <#BB2726>",
  "8c49e1dc4a": "Se requiere verificación humano-máquina",
  "4b8ba7d8cc": "Nueva plataforma de productividad para oficina",
  "81be771e17": "🎉¡Empresa creada exitosamente! Completa la información para obtener servicios exclusivos",
  "461125b057": "Puede gestionar documentos y materiales en el equipo. Los miembros del equipo pueden verlos fácilmente y también pueden establecer permisos de edición/descarga para garantizar la seguridad de los datos.",
  "c3eb25029b": "Tamaño de la empresa/equipo",
  "049f8401ec": "Menos de 5 personas",
  "c81896349e": "6-20 personas",
  "7357daac4e": "21-50 personas",
  "f0e65a0a29": "51-100 personas",
  "b9fac8204a": "101-200 personas",
  "62d73dddaf": "201-500 personas",
  "3bcdaf7160": "501-2000 personas",
  "ab0b2333fe": "Más de 2000 personas",
  "4f756eedc8": "Tu rol es",
  "3ba0b502c3": "Director General",
  "702099cc72": "Financieras",
  "843b603162": "Compras",
  "8b414a9b44": "Recursos Humanos/Administración",
  "92486b2908": "Ventas",
  "ac4e7fb063": "¿Tiene su organización un presupuesto/plan de compra para software de oficina?",
  "37634c72dc": "Dentro de 6 meses",
  "bd94b6deec": "Dentro de 1 año",
  "713f4aad5c": "Considerándolo",
  "c5ea095a4d": "Sin plan",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Crea un equipo e invita a los miembros para colaborar juntos",
  "9d27dc2d90": "Puede ingresar el nombre del equipo o el proyecto seguido recientemente",
  "de19c8509a": "Es posible que desees crear:",
  "1a84699223": "Departamento de Ventas",
  "efab59502b": "Departamento de Producto",
  "7e599b3713": "Departamento de Operaciones del Sur",
  "bf494779c2": "Departamento de Compras",
  "f3a60ab34d": "Departamento de Administración",
  "bbc50c1ac8": "Departamento de Finanzas del Norte",
  "32629e3dac": "Departamento de Finanzas de Producto",
  "5524d354ba": "Departamento de IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>¡Has desbloqueado beneficios de principiante!</span> Invita a 3 personas más para obtener <span style='color: rgb(206,131,62);'>4T de espacio y derechos de WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Has desbloqueado el límite de 50 personas y los derechos de carga máxima de un solo archivo de 4G</span>. Continúa invitando a 3 personas para desbloquear 30 días de WPS AI y derechos de espacio de 4T",
  "136c26d941": "Copia el enlace a continuación e invita a miembros a unirse",
  "3de5c12558": "Copia el enlace e invita a tus colegas",
  "a5d64b14f3": "Guía de información de la empresa",
  "b8f2492701": "Recopilación de información de la empresa",
  "1f9d053dc0": "Crear plantilla de equipo",
  "0e83c79a88": "Invitar miembros",
  "821fc1906a": "Entrar en la empresa",
  "463e14ae9c": "Por favor seleccione un equipo",
  "690f0cdb9e": "Completar ícono",
  "c340522a17": "Anterior",
  "f9355c72ef": "Saltar",
  "bd6c09ebbb": "siguiente",
  "2a2603cd3f": "Escanear para enviar invitación a colegas",
  "411e64907a": "Copiar",
  "b0d988cf23": "Descargar",
  "e3c0b650ac": "Se ha copiado correctamente",
  "713ac624b4": "Bienvenido a WPS 365",
  "b8fff97849": "Elemento destino no válido",
  "02acdcf296": "html2canvas fallo en la conversión, no se generó canvas",
  "a76988c496": "Falló la conversión de canvas a blob",
  "af89584edf": "API del portapapeles no disponible",
  "f90263bbde": "Falló la copia de imagen",
  "71b05319da": "Falló la conversión de HTML a canvas",
  "38852999fe": "Falló en guardar información",
  "4a4c621d07": "Error al Crear Equipo, Por Favor Intente Nuevamente Más Tarde",
  "d239a23994": "Esta Página Solo Está Disponible Para Cuentas Empresariales, Por Favor Inicie Sesión Con Su Cuenta Empresarial Primero.",
  "d93bfb7fb9": "Escriba el contenido",
  "42b81a66c4": "La longitud debe estar entre 2 y 100 caracteres",
  "76d33733db": "No puede contener / \\ ; : * ? \" < > | % & y otros caracteres especiales",
  "dc55d1f62f": "Ir a la Experiencia",
  "b25233cba0": "Colaboración de documentos + comunicación instantánea, inicia una nueva forma de trabajo eficiente",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Inicia un chat en grupo para colaborar, seguro y fácil de compartir documentos",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Asistente AI Lingxi, un asistente inteligente creado especialmente para la oficina",
  "e338385bc9": "Oficina Nativa Inteligente, profundamente integrada con IA y software de oficina, permite a cada persona tener un asistente de IA",
  "7ae1f3b1c6": "Importación de archivos (carpetas) completada, puede verificar los resultados en 'Mis Documentos en la Nube'",
  "85db2a024a": "Error en la importación de archivos (carpetas), puede intentarlo nuevamente más tarde",
  "9ff74c802a": "Descargar versión para chips Intel",
  "ab44928f02": "Descargar versión para chips Apple",
  "a08d937c38": "Subida de archivos (carpetas) en curso, podrá verlos en 'Mis Documentos en la Nube' una vez completados",
  "68db1829fa": "Solo se admite la importación desde una cuenta personal, por favor inicie sesión en su cuenta personal e intente de nuevo.",
  "1185a7c7ab": "Menos de 20 personas",
  "e2bcc252c9": "21-300 personas",
  "3c4842f1ea": "301-1000 personas",
  "1bbee64cfa": "Más de 1000 personas",
  "388ff4a035": "Profesor",
  "d341b1d794": "Estudiante",
  "bfb2ee4148": "Más",
  "f6450c3f31": "Gestión de Proyectos",
  "b87fd33a0d": "Plan Anual",
  "0dd45a1c14": "Gestión del Rendimiento de los Empleados",
  "67fa01cac6": "Actividades de Marketing",
  "6dd82cc031": "Reclutamiento de Empleados",
  "a7edaed91d": "Material Didáctico",
  "bf12b7efb0": "Gestión del Plan de Estudio",
  "c35ae8f358": "Documentación del Producto",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Hojas Multidimensionales, crea un sistema de negocio personalizado de forma visual",
  "72286d5519": "👏Plantillas Recomendadas",
  "0bc00ee949": "Gestión de Defectos de Requisitos",
  "e22f3d56f7": "Gestión de Creación de Contenidos",
  "dd439de3dd": "Sistema de Gestión de Clientes",
  "fbb2bbf82e": "Plan de Estudio",
  "0645b908bc": "Consulta de Nómina",
  "813b3d3d7e": "Gestión de OKR",
  "918e33d5bd": "Crear con un Solo Click",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importar Documentos Frecuentes, más conveniente",
  "c58f28713c": "Importar desde Local",
  "9d6a0a4370": "Admite formatos de archivo comunes de Office",
  "54c48aee85": "Seleccionar archivo",
  "c5b593e452": "Importar desde Cuenta Personal",
  "4bdcd9d4c5": "Importar Documentos, Equipos y Carpetas de la Cuenta Personal con un Solo Click",
  "99b2968905": "Importar Autorizado",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Descargar Cliente de WPS Teams",
  "fe46574227": "Colaboración de Documentos + Mensajería Instantánea, Nueva Forma de Trabajo Eficiente",
  "beefe5a09b": "Descargar ahora mismo",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Configuraciones de Seguridad Abundantes, Protección de Datos Segura",
  "b4e70dbeab": "Capacidad de Seguridad de Documentos de WPS Acumulada Durante Años, Garantiza Que No Se Filtren Datos Críticos de la Empresa",
  "42dc772619": "El archivo es demasiado grande, recomendamos reintentar la importación en la página de inicio más tarde",
  "a052564e47": "Error en la Creación, Por Favor Intente Más Tarde"
}